module.exports = __webpack_public_path__ + "public/img/luing.fa6efefc.gif";